import { FC, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import './ClientTable.scss';

import ClientsTableExpandable from './ClientTableExpandable';

import { GroupedObject, ObjectItem } from 'api/clients/types';
import useDeleteObject from 'hooks/Object/useDeleteObject';
import DeleteModal from 'components/DeleteModal/DeleteModal';
import { useGetObjectsColumns } from 'hooks/Clients/useGetObjectsColumns';
import ObjectListDataTable from 'components/FilterDataTable/ObjectListDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';

interface ClientTableProps {
  data: ObjectItem[];
  rootClient?: GroupedObject;
  selectedObject: ObjectItem | undefined;
  refetchClients: () => void;
  setSelectedObject: (obj: ObjectItem | undefined) => void;
  setIsManageObjectModalOpen: (value: boolean) => void;
}
const ClientTable: FC<ClientTableProps> = ({
  data,
  selectedObject,
  refetchClients,
  setSelectedObject,
  setIsManageObjectModalOpen,
}) => {
  const { isNotDesktop } = useScreenSize();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const columns = useGetObjectsColumns({
    setSelectedObject,
    setIsDeleteModalOpen,
    setIsManageObjectModalOpen,
  });

  const { deleteObject } = useDeleteObject();
  const { t } = useTranslation();

  const onDelete = () => {
    deleteObject(selectedObject?.id || 0, {
      onError: (error: any) => {
        if (error.response.data.detail) {
          enqueueSnackbar(error.response.data.detail, { variant: 'error' });
        }
      },
      onSuccess: () => {
        enqueueSnackbar(t('ClientTable.delete-modal-success-message'), { variant: 'success' });
        setIsDeleteModalOpen(false);
        setSelectedObject(undefined);
        refetchClients();
      },
    });
  };
  return (
    <div className="">
      {!data || !data.length ? (
        <div className="list d-flex justify-content-center form-check-all ">
          <div>
            <span className="text-center">{t('ClientTable.no-data')}</span>
          </div>
        </div>
      ) : (
        <ObjectListDataTable<ObjectItem>
          columns={columns}
          data={data}
          isLoading={false}
          expandableRows={isNotDesktop}
          expandableRowsComponent={row => (
            <ClientsTableExpandable
              data={row.data}
              setIsDeleteModalOpen={setIsDeleteModalOpen}
              setIsManageObjectModalOpen={setIsManageObjectModalOpen}
              setSelectedObject={setSelectedObject}
            />
          )}
        />
      )}
      <DeleteModal
        title={t('ClientTable.delete-modal-title')}
        objectName={selectedObject?.name || ''}
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={onDelete}
        refetchClients={refetchClients}
      />
    </div>
  );
};

export default ClientTable;
